module.exports = __webpack_public_path__ + "static/media/reject-icon.3f4a727f.svg";